import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {FabricFilterService} from '../service/fabric-filter.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ProductListingTransmissionService} from 'src/app/raintree/transmission/product-listing/product-listing-transmission.service';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';
import {FilterControl} from '../interface/filter-control';
// import { RequestMapperService } from 'src/app/request-mapper.service';
import {RangeFilterControl} from '../interface/range-filter-control';
import {FilterUrlModifierService} from "../service/filter-url-modifier.service";
import {StoreFilterControlService} from "../service/store-filter-control.service";

@Component({
	selector: 'fb-product-filter-sidebar',
	templateUrl: './product-filter-sidebar.component.html',
	styleUrls: ['./product-filter-sidebar.component.scss']
})


export class ProductFilterSidebarComponent {
	@Input() productList: ProductListing[] = [];
	@Output() onFilterChangeProductLength = new EventEmitter<number>();
	public controls: FilterControl = {} as FilterControl;
	// @Output() onFilteredProducts = new EventEmitter<ProductListing[]>(); //for filtering through filtered item
	public fabrics: ProductListing[] = [];
	public filteredFabrics: ProductListing[] = [];
	public isFabric = true;

	constructor(
		private _filterService: FabricFilterService,
		private _productListingTransmissionService: ProductListingTransmissionService,
		private _activatedRoute: ActivatedRoute,
		private _urlModifier: FilterUrlModifierService,
		private _setControlsObservable : StoreFilterControlService
	) {
	}

	public readParam(urlString: Params): void {
		console.log(urlString);
		// console.log(this.controls);
	}

	public seekFilterChanges(): void {

		this.filteredFabrics = this._filterService.prepareFilterResults(
			this.controls,
			this.fabrics
		);
		this.onFilterChangeProductLength.emit(this.filteredFabrics.length);

		// TODO: url modifier call
		this._urlModifier.modify(this.controls);
	}

	public ngOnInit(): void {

		this._activatedRoute.params.subscribe(params => {

			if (params['category'] != "fabric" ) {
				this.isFabric = false;
			}
			if ( params['category'] =="display" ) {
				this.isFabric = false;
			}

		});

	}

	public ngOnChanges(changes: SimpleChanges) {
		// debugger
		if (changes['productList']['currentValue']) {
			// console.log(this.productList)
			this.fabrics = this.productList;
			this.filteredFabrics = [...this.productList];
			this._prepareControls();
			this._activatedRoute.queryParams.subscribe(params => {
				this.readParam(params)
			});

			// for (var i = 0; i < this.productList.length; i++) {
			// 	if(this.productList[i].product.productGroup === 'fabric') {
			// 		this.isFabric = true;
			// 		break
			// 	}
			// 	else {
			// 		this.isFabric = false;
			// 	}
			// }
		}

		// this.totalQuantity =  this.totalQuantityFromParent;
	}

	private _prepareControls(): void {
		this.controls = this._filterService.prepareFilterControls(this.fabrics);
		// debugger
		if (!this.isFabric) {
			this.controls.rangeFilterControls.forEach((elm: RangeFilterControl, i: number) => {

				if (elm.key == 'gsm') {
					this.controls.rangeFilterControls.splice(i, 1)
				}
			})
		}
		this._setControlsObservable.storedControl.next(this.controls)
		// console.log(this.controls);


	}
}
